import Element from './element';

class PositionManager {
    private body!: Element;

    /**
     * Procedura ustawiająca główny element, który posłuży jako punkt odniesienia do obliczeń.
     * @param body Korpus projektowanego mebla.
     */
    public initialize(body: Element) {
        this.body = body;
    }

    /**
     * Procedura umieszczająca element w odpowiednim miejscu na scenie.
     * @param element Element, który należy umieścić w odpowiednim miejscu na scenie.
     */
    public position(element: Element) {
        const body = this.body;
        const cellWidth = body.width / body.shape.x;
        const cellHeight = body.height / body.shape.y;
        const position = element.center;
        const avgX = (1 + body.shape.x) / 2;
        const avgY = (1 + body.shape.y) / 2;
        const offsetX = (element.position.x - avgX) + (0.5 * (element.shape.x - 1));
        const offsetY = (element.position.y - avgY) - (0.5 * (element.shape.y - 1));
        position.x = body.center.x + offsetX * cellWidth;
        position.y = body.center.y + offsetY * cellHeight;
        element.center = position;
    }
}

export const positionManager = new PositionManager();

/* Oznaczenia poszczególnych komórek korpusu.
----------
|13|23|33|
----------
|12|22|32|
----------
|11|21|31|
----------
*/
